var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":'/onboarding/' + _vm.to,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var navigate = ref.navigate;
var href = ref.href;
var isActive = ref.isActive;
return [_c('li',[_c('a',{staticClass:"nav-link border-left border-5",class:isActive || _vm.active ? 'border-green router-link' : 'disabled',attrs:{"href":href},on:{"click":navigate}},[_vm._v(_vm._s(_vm.label))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }